import React from 'react';

function Hero() {
  return (
    <section className="hero-section">
      <div className="hero-bg-gradient"></div>
      <div className="hero-grid-lines"></div>
      <div className="accent-orb" style={{ width: 500, height: 500, top: -100, right: -100 }}></div>

      <div className="hero-content">
        <div className="hero-grid">
          {/* Left */}
          <div>
            <div className="hero-fade" style={{ animationDelay: '0.3s', marginBottom: '2rem' }}>
              <span className="label-tag">
                <span className="pulse-dot"></span>
                Open for Projects — 2026
              </span>
            </div>

            <h1 className="hero-title">
              <span className="hero-line"><span className="hero-line-inner" style={{ color: '#f2f2f2' }}>We engineer</span></span>
              <span className="hero-line"><span className="hero-line-inner" style={{ color: '#f2f2f2' }}>digital</span></span>
              <span className="hero-line"><span className="hero-line-inner" style={{ color: '#e8553d' }}>experiences.</span></span>
            </h1>

            <p className="hero-fade hero-subtitle" style={{ animationDelay: '0.55s' }}>
              Square Production is a technology studio that transforms ambitious ideas into high-performance software. We design, build, and scale products people love.
            </p>

            <div className="hero-fade hero-buttons" style={{ animationDelay: '0.7s' }}>
              <a href="#work" className="btn-ember" onClick={(e) => { e.preventDefault(); document.querySelector('#work')?.scrollIntoView({ behavior: 'smooth' }); }}>
                See Our Work <i className="fa-solid fa-arrow-down-right" style={{ fontSize: '0.75rem' }}></i>
              </a>
              <a href="#contact" className="btn-ghost" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}>
                Get in Touch <i className="fa-solid fa-arrow-right" style={{ fontSize: '0.75rem' }}></i>
              </a>
            </div>

            <div className="hero-fade hero-stats" style={{ animationDelay: '0.85s' }}>
              <div>
                <p className="stat-number sm">150+</p>
                <p className="stat-label">PROJECTS</p>
              </div>
              <div className="hero-stat-divider"></div>
              <div>
                <p className="stat-number sm">50+</p>
                <p className="stat-label">CLIENTS</p>
              </div>
              <div className="hero-stat-divider"></div>
              <div>
                <p className="stat-number sm">99%</p>
                <p className="stat-label">RETENTION</p>
              </div>
            </div>
          </div>

          {/* Right - Hero Image */}
          <div className="hero-fade" style={{ animationDelay: '0.4s' }}>
            <div className="hero-img-wrapper">
              <img
                src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&q=80"
                alt="Modern development workspace with code on multiple screens"
              />
              <div className="hero-img-gradient"></div>

              <div className="hero-img-card">
                <div className="hero-img-card-header">
                  <span className="hero-img-card-label">Latest Project</span>
                  <span className="hero-img-card-dot"></span>
                </div>
                <p className="hero-img-card-title">FinanceHub — Trading Platform</p>
                <p className="hero-img-card-tech">React · Node.js · AWS · Real-time Data</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
